package one.healthium.log_food.data

import one.healthium.db.FoodEntity
import one.healthium.log_food.domain.FoodModel

class FoodMapper {
    fun dtoToModel(dto: FoodDto): FoodModel {
        return FoodModel(
            product = dto.product,
            emoji = dto.emoji,
            description = dto.description,
            calories = dto.calories,
            fat = dto.fat,
            carbohydrates = dto.carbohydrates,
            fiber = dto.fiber,
            protein = dto.protein,
            tablespoon = dto.tablespoon,
            cups = dto.cups,
            pieces = dto.pieces,
            isLiquid = dto.isLiquid,
        )
    }

    fun dtoToEntity(dto: FoodDto): FoodEntity {
        return FoodEntity(
            id = 0,
            product = dto.product,
            emoji = dto.emoji,
            description = dto.description,
            calories = dto.calories.toDouble(),
            fat = dto.fat.toDouble(),
            carbohydrates = dto.carbohydrates.toDouble(),
            fiber = dto.fiber.toDouble(),
            protein = dto.protein.toDouble(),
            tablespoon = dto.tablespoon?.toDouble(),
            cups = dto.cups?.toDouble(),
            pieces = dto.pieces?.toDouble(),
            isLiquid = if (dto.isLiquid) 1L else 0L,
        )
    }

    fun entityToModel(entity: FoodEntity): FoodModel {
        return FoodModel(
            product = entity.product,
            emoji = entity.emoji,
            description = entity.description,
            calories = entity.calories.toFloat(),
            fat = entity.fat.toFloat(),
            carbohydrates = entity.carbohydrates.toFloat(),
            fiber = entity.fiber.toFloat(),
            protein = entity.protein.toFloat(),
            tablespoon = entity.tablespoon?.toFloat(),
            cups = entity.cups?.toFloat(),
            pieces = entity.pieces?.toFloat(),
            isLiquid = entity.isLiquid == 1L,
        )
    }
}